(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-search"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('faq-search')) {
    customElements.define(
      'faq-search',
      class FaqSearch extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input[type="search"]');
          this.message = this.querySelector('[role="status"]');
          const sectionWrapper = this.closest('.shopify-section');
          let faqSection = sectionWrapper?.nextElementSibling;
          while (faqSection && !faqSection.querySelector('.accordion-item')) {
            faqSection = faqSection.nextElementSibling;
          }
          this.items = [...(faqSection?.querySelectorAll('.accordion-item') || [])];

          if (!this.input || this.items.length === 0) return;
          if (faqSection.id) this.input.setAttribute('aria-controls', faqSection.id);
          this.input.addEventListener('input', this.filterItems);
        }

        disconnectedCallback() {
          this.input?.removeEventListener('input', this.filterItems);
        }

        filterItems = () => {
          const query = this.input.value.trim().toLocaleLowerCase();
          let visibleCount = 0;

          for (const item of this.items) {
            const matches = query === '' || item.textContent.toLocaleLowerCase().includes(query);
            item.hidden = !matches;
            if (matches) visibleCount += 1;
          }

          this.message.textContent = query && visibleCount === 0 ? this.dataset.noResults : '';
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
